import React from 'react';

import { ProfilFourriereViolationDtoFormFieldEnum } from 'lib_api/lib/api/gen';

import { UntypedField } from 'components/WrappedComponents';
import { useApi } from 'hooks/ApiStoreContext';
import { useUserStore } from 'hooks/UserStoreContext';
import {
  FicheProfilFourriereBlocFourriere,
  InputPropFourriere,
  SemaineHoraire,
} from 'types/FicheProfil/FicheProfilGardienFourriere';
import { CSSUtils } from 'utils/CSSUtils';

import { validateFicheProfilGf } from '../../utils';
import ButtonCreateModal from '../Modal/ButtonCreateModal';

type InputHoraireProps = InputPropFourriere & {
  setValues: (values: SemaineHoraire) => void;
};

const InputHoraire = ({
  values,
  setValues,
  generateRequestDto,
  isEditable,
}: InputHoraireProps): React.ReactElement => {
  const user = useUserStore();
  const gfController = useApi().GardienFourriereControllerApi;
  const fieldKey: keyof FicheProfilFourriereBlocFourriere = 'horaires';

  return (
    <UntypedField
      fieldKey={fieldKey}
      itemProps={{
        label: "Horaires d'ouvertures",
        labelCol: { span: CSSUtils.defaultLabelCol },
        wrapperCol: { span: CSSUtils.largeWrapperCol },
        valuePropName: 'horaires',
        rules: [
          {
            validator: async (_rule, value: SemaineHoraire): Promise<void> => {
              return validateFicheProfilGf(
                gfController,
                ProfilFourriereViolationDtoFormFieldEnum.HORAIRES,
                user.idCorrelationFourriere || '',
                generateRequestDto({ ...values, [fieldKey]: value }),
              );
            },
          },
        ],
      }}
      editable={isEditable}
      WrappedInput={
        <ButtonCreateModal
          values={values}
          setValues={setValues}
          title={<>Éditer les horaires</>}
        />
      }
      ConsultationElement={
        <ButtonCreateModal
          values={values}
          title={<>Consulter les horaires</>}
        />
      }
    />
  );
};

export default InputHoraire;
